export default {"src":"/_next/static/media/next.e54be70c.svg","height":1365,"width":1365,"blurWidth":0,"blurHeight":0};